import { render, staticRenderFns } from "./TopicsList.vue?vue&type=template&id=36f9f9a9&scoped=true&"
import script from "./TopicsList.vue?vue&type=script&lang=ts&"
export * from "./TopicsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9f9a9",
  null
  
)

export default component.exports